/**
 *
 * Copyright 2020-2026 Splunk Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 */

export const BROWSER_NAVIGATION_DETECTED_RESOURCE_COUNT_ATTRIBUTE = 'browser.navigation.detected_resource_count'
export const BROWSER_NAVIGATION_LAST_LOADED_RESOURCES_ATTRIBUTE = 'browser.navigation.last_loaded_resources'
export const BROWSER_NAVIGATION_LOADING_RESOURCE_COUNT_ATTRIBUTE = 'browser.navigation.loading_resource_count'
export const BROWSER_NAVIGATION_LOADING_RESOURCE_URLS_ATTRIBUTE = 'browser.navigation.loading_resource_urls'
export const BROWSER_NAVIGATION_LONGEST_LOADED_RESOURCE_ATTRIBUTE = 'browser.navigation.longest_loaded_resource'
export const BROWSER_NAVIGATION_OPERATION_ATTRIBUTE = 'browser.navigation.operation'
export const BROWSER_NAVIGATION_PAGE_COMPLETION_TIME_ATTRIBUTE = 'browser.navigation.page_completion_time'
export const BROWSER_NAVIGATION_PAGE_SPAN_ID_ATTRIBUTE = 'browser.navigation.page_span_id'
export const BROWSER_NAVIGATION_PCT_RELEVANT_ATTRIBUTE = 'browser.navigation.pct_relevant'
export const BROWSER_NAVIGATION_QUIET_TIMER_RESET_COUNT_ATTRIBUTE = 'browser.navigation.quiet_timer_reset_count'
export const BROWSER_NAVIGATION_STATUS_ATTRIBUTE = 'browser.navigation.status'

export const BROWSER_NAVIGATION_DOCUMENT_LOAD_OPERATION = 'documentLoad'
export const BROWSER_NAVIGATION_ROUTE_CHANGE_OPERATION = 'routeChange'

export const PAGE_LOAD_METRICS_STATUS_COMPLETED = 'completed'
export const PAGE_LOAD_METRICS_STATUS_INTERRUPTED = 'interrupted'
export const PAGE_LOAD_METRICS_STATUS_TIMEOUT = 'timeout'
